// extracted by mini-css-extract-plugin
export default {"modal":"EditSoils_modal__fcIn+","modalDialog":"EditSoils_modalDialog__4vdmV","projectWrapper":"EditSoils_projectWrapper__eGcLU","p":"EditSoils_p__BLuiH","row":"EditSoils_row__Z0-vg"};